import { render } from "./FilterRegional.vue?vue&type=template&id=24619646"
import script from "./FilterRegional.vue?vue&type=script&lang=js"
export * from "./FilterRegional.vue?vue&type=script&lang=js"
script.render = render

export default script